module.exports = __webpack_public_path__ + "img/furbolg_elder_shaman_small.ed5479d0.png";